module.exports = __webpack_public_path__ + "img/logo_market.debb9c97.svg";